/** @jsx jsx */
import { jsx } from "@emotion/core";
import React, { useState, Fragment } from "react";
import { SiteLink } from "../../components";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { NavBar } from "./navBar";
// import { DayNight } from "./dayNight";
import { BackButton } from "../backButton/backButton";
import { Hamburger } from "../hamburger/hamburger";
import style from "./topHeaderStyle2";
import { useStore } from "../../store";
import { NavBarHori } from "./navBarHori";
import { isMobile } from "@site/siteUtils";

export function TopHeader(props) {
  const [menuOpened, setMenuOpened] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { state } = useStore();

  useScrollPosition(
    ({ prevPos, currPos }) => {
      if (currPos.y > 90) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    },
    [],
    null,
    true
  );

  function toggleMenu(e) {
    setMenuOpened(!menuOpened);
  }
  function onCloseMenu() {
    setMenuOpened(false);
  }

  return (
    <Fragment>
      <header
        className={`header`}
        css={[style.top]}
        id='top'
      >
        <div
          className='top__navi__con__wrap'
          css={[style.top__navi__con__wrap]}
        >
          <div className='top__navi__con' css={[style.top__navi__con]}>
            <NavBarHori
              open={menuOpened}
              onCloseMenu={onCloseMenu}
            ></NavBarHori>
            <BackButton />
          </div>

          {/*<BackButton />*/}
        </div>
            <div
              style={{ width: "100%", height: "100%", position: "relative" }}>
              <div
                className='home__toggle__contents__con'
                css={[style.home__toggle__contents__con]}>
                          <div
                            className='home__toggle__contents__item'
                            style={{ display: "flex" }}
                            css={style.home__toggle__contents__item}>
                            <div className="main-logo-mobile">
                              <SiteLink to='/'>
                                <img
                                  src='/assets/logos/logo.png'
                                  alt='logo'
                                  width='100%'
                                />
                              </SiteLink>
                            </div>
                            <a
                              className='header__call__button'
                              href='tel:0883638833'
                              css={style.header__call__button}
                            >
                            <img src='/assets/phone-icon-green.png' alt='phone icon' />
                          </a>
                            <Hamburger
                              opened={menuOpened}
                              toggleMenu={toggleMenu}
                              scrolled={scrolled}
                              state={state}
                            />
                          </div>
              </div>
            </div>
        <NavBar open={menuOpened} onCloseMenu={onCloseMenu}></NavBar>
      </header>
    </Fragment>
  );
}

// const DayNightItem = React.memo(function DayNightItem() {
//   return <DayNight />;
// });
